export const NavItems = [
  {
    to: "/projects",
    title: "Projects",
  },
  {
    to: "/practices",
    title: "Practices",
  },
  {
    to: "/radar",
    title: "Radar",
  },
  {
    to: "/bookshelf",
    title: "Bookshelf",
  },
  {
    to: "/about",
    title: "About",
  }
];